import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db119e8e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=db119e8e&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db119e8e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterTool: require('/builds/master/frontend/frontend-universe/components/filterTool.vue').default,Card: require('/builds/master/frontend/frontend-universe/components/card/card.vue').default,Empty: require('/builds/master/frontend/frontend-universe/components/empty.vue').default,Badage: require('/builds/master/frontend/frontend-universe/components/badage.vue').default,Subscription: require('/builds/master/frontend/frontend-universe/components/subscription/subscription.js').default})
